import axios from '@/axios/api.request'

export const save = (from) => axios.request({
  url: '/patent/sale/save',
  data: from,
  method: 'post'
})

export const join = (from) => axios.request({
  url: '/patent/sale/join',
  data: from,
  method: 'post'
})
export const imports = (form) => axios.request({
  url: '/patent/sale/import',
  data: form,
  method: 'post'
})